"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldLabel = void 0;

var tslib_1 = require("tslib");

var ui_char_count_1 = require("@hopin-team/ui-char-count");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var FieldLabel = function FieldLabel(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      charCountId = _a.charCountId,
      charCountText = _a.charCountText,
      className = _a.className,
      currentCount = _a.currentCount,
      _b = _a.element,
      element = _b === void 0 ? 'label' : _b,
      fieldId = _a.fieldId,
      id = _a.id,
      isDisabled = _a.isDisabled,
      isInverse = _a.isInverse,
      isLegend = _a.isLegend,
      isRequired = _a.isRequired,
      label = _a.label,
      maxCount = _a.maxCount,
      onClick = _a.onClick,
      _c = _a.requiredText,
      requiredText = _c === void 0 ? 'required' : _c;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'FieldLabel',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var withCharCount = Boolean(charCountId) && typeof currentCount === 'number' && typeof maxCount === 'number'; // Only one of the id methods should exist depending on the type of the
  // element.

  var a11yProps = {};

  if (isLegend) {
    a11yProps.id = fieldId;
  } else {
    a11yProps.htmlFor = fieldId;
  }

  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    withDecorators: withCharCount,
    "data-testid": testID,
    id: id,
    onClick: onClick
  }, react_1.default.createElement(ui_text_1.Text, tslib_1.__assign({
    element: element,
    pattern: "captionMedium",
    color: isDisabled ? 'grey-600' : isInverse ? 'grey-white' : 'grey-800'
  }, a11yProps), label, isRequired && react_1.default.createElement(ui_text_1.Text, {
    pattern: "captionMedium",
    color: isInverse ? 'grey-400' : 'grey-600',
    ml: 0.5
  }, "(", requiredText, ")")), withCharCount && react_1.default.createElement(ui_char_count_1.CharCount, {
    currentCount: currentCount,
    maxCount: maxCount,
    id: charCountId,
    charCountText: charCountText,
    __UIScope: __UIScope
  }));
};

var FieldLabelWithSpace = (0, ui_helper_with_space_1.withSpace)(FieldLabel);
exports.FieldLabel = FieldLabelWithSpace;